export enum AppColors {
  white = 'white',
  black = 'black',
  primary_50 = 'primary-50',
  primary_100 = 'primary-100',
  primary_200 = 'primary-200',
  primary_300 = 'primary-300',
  primary_400 = 'primary-400',
  primary_500 = 'primary-500',
  primary_600 = 'primary-600',
  primary_700 = 'primary-700',
  primary_800 = 'primary-800',
  primary_900 = 'primary-900',
  accent_50 = 'accent-50',
  accent_100 = 'accent-100',
  accent_200 = 'accent-200',
  accent_300 = 'accent-300',
  accent_400 = 'accent-400',
  accent_500 = 'accent-500',
  accent_600 = 'accent-600',
  accent_700 = 'accent-700',
  accent_800 = 'accent-800',
  accent_900 = 'accent-900',
  warn_50 = 'warn-50',
  warn_100 = 'warn-100',
  warn_200 = 'warn-200',
  warn_300 = 'warn-300',
  warn_400 = 'warn-400',
  warn_500 = 'warn-500',
  warn_600 = 'warn-600',
  warn_700 = 'warn-700',
  warn_800 = 'warn-800',
  warn_900 = 'warn-900',
  black_50 = 'black-50',
  black_100 = 'black-100',
  black_200 = 'black-200',
  black_300 = 'black-300',
  black_400 = 'black-400',
  black_500 = 'black-500',
  black_600 = 'black-600',
  black_700 = 'black-700',
  black_800 = 'black-800',
  black_900 = 'black-900',
}

export const APPROVAL_COLOR = '#f5bd00';
export const PRESET_COLOR = '#008080';
export const PRESET_BG_COLOR = '#e4f6ef';

export const PRIMARY_BG_COLOR = '#edf3f9';
export const ACCENT_BG_COLOR = '#cdf9f0';
export const WARN_BG_COLOR = '#ffcdd2';
